
import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
// reactstrap components
import {
  Button, InputGroup, InputGroupText,
  Card,Badge,
  CardHeader,ModalHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Modal,
  ModalBody,
} from "reactstrap";
import {fieldvalidator, filenamevalid, alphanum, numdtest, alphaspace} from '../../../helpers/validate'
import {customStyles} from '../../../helpers/mycomps'
  

  import { useSelector} from 'react-redux'
  import { connect } from 'react-redux'
  import { profileFetch } from "actions/actions";

import dlogo from "../../images/Logo.jpeg"
import dp from "../../images/dp.jpg"
import { Rating } from 'react-simple-star-rating'


function Tenant(props) {
  const [showProcessing , setShowProcessing] = useState(true)
  const [showLogoProcessing , setShowLogoProcessing] = useState(false)
  const [fulltextsearch, setFulltextsearch] = useState("")
  const [tenantslist, setTenantslist] = useState([])
  const [showlist, setShowlist] = useState(true)
  const hiddenFileInput = useRef(null);
  const [tenant , setTenant] = useState({
    tid : "",
    tuid : "",
    managerid : "",
    enqEmail : "",
    mngName : "",
    cellNumber : "",
    cellNumberc : "",
    landLine : "",
    cellIsVerified : false,
    waNumber  :"",
    liProfile : "",
    fbProfile : "",
    insProfile : "",
    stAddr  :"",
    addressIsVerified : false,
    postal : "",
    aboutWords : "",
    aboutWordsar : "",
    timage : "",
    rating : 0
   })

  const [updateMode, setUpdateMode] = useState(false)
  const [tname, setTname] = useState({en : "", fr : "", ar : ""})
  const [area, setArea] = useState({areaCode : "", en : "", fr : "", ar : ""})
  const [city, setCity] = useState({cityCode : "", en : "", fr : "", ar : ""})
  const [allowedCategories, setAllowedCategories] = useState({cars : false, yacht : false, machines : false})
  const [allowed, setAllowed] = useState({listing : 0, premium : 0, featured : 0})
  const [newPassword, setNewPassword] = useState("")
  const [editP, setEditP] = useState({listing : false, premium : false, featured : false})
  const [showpwc, setShowpwc] = useState(false)
  const [alert, setAlert] = React.useState(null);
  const [opass, setOpass] = React.useState("");
  const [cpass, setCpass] = React.useState("");

  const storarea  = useSelector(state => state.areaStore.areaData).map(x => {
   
    return {
      label :x.cityName.en  , value : x.cityCode, 
      labelfr : x.cityName.fr, labelar : x.cityName.ar,
      areas : x.area
    }
  })

  const [arealist, setArealist] = useState([])

  const [bank , setBank] = useState({
    bankName : "",
    swiftCode : "",
    routingCode : "",
    iban : "",
    account : ""
  })

  const [{alt, src}, setImg] = useState({
    src: dp,
    alt: ''
  });
  const [filenames, setFilenames] = useState()
  

  const clearvalues = () => {
    setTenant({
      tid : "",
      tuid : "",
      managerid : "",
      enqEmail : "",
      mngName : "",
      cellNumber : "",
      cellNumberc : "",
      landLine : "",
      cellIsVerified : false,
      waNumber  :"",
      liProfile : "",
      fbProfile : "",
      insProfile : "",
      stAddr  :"",
      addressIsVerified : false,
      postal : "",
      aboutWords : "",
      aboutWordsar : "",
      timage : "",
      rating : 0
     }) ;
     setTname({en : "", fr : "", ar : ""})
     setArea({aid : "", en : "", fr : "", ar : ""})
     setCity({cid : "", en : "", fr : "", ar : ""})
     setAllowedCategories({cars : false, yacht : false, machines : false})
     setNewPassword("")
     setBank({
      bankName : "",
      swiftCode : "",
      routingCode : "",
      iban : "",
      account : ""
    })
    setAllowed({listing : 0, premium : 0, featured : 0})
    setImg({
      src : dp,
      alt : ""
    })
  }

  useEffect(() => {
    if(props.user.Email){
      ftenant()
    }  

  }, [])

  const submitCreate = () => {
    if(fieldvalidator(tname.en, tenant.managerid, tenant.cellNumberc , tenant.cellNumber, tenant.mngName )){
     props.swal("Tenant Required Fields are EMPTY!")
    }else{
     
      setShowProcessing(true)
      let formData = new FormData(); 
      formData.append("tenantLogo" , filenames)
      formData.append("tname", JSON.stringify(tname) );
      formData.append("tenant", JSON.stringify(tenant) );
      formData.append("bank", JSON.stringify(bank) );
      formData.append("allowed", JSON.stringify(allowed) );
      formData.append("allowedCategories" , JSON.stringify(allowedCategories))
      formData.append("city", JSON.stringify(city) );
      formData.append("area", JSON.stringify(area) );
      props.API({
        method: "post",
        url : `tenant/tenant`,
        data: formData
        }).then((res) => {
            props.swal("Tenant Created!")
          setShowProcessing(false)
       
        }).catch(function (error) {
          setShowProcessing(false)
          try{
            if(error.response.status === 401){
              props.swal("Unauthorized, please login again.").then(t => {
                  props.history.push(`/auth/login`)
              })   
            }else{
              props.swal(error.response.data.message)
            }
          } catch(e){
            props.swal("error processing request at this time, please contact support.")
          } 
         
        //  console.log(error.response)
         
           console.log("error")
    }) 
    }
    return
     // inputConfirmAlert("Are you sure")
    

      //props.props.swal(msg)
  }

  const submitUpdate = () => {
    if(fieldvalidator(tname.en, tenant.managerid, tenant.cellNumberc , tenant.cellNumber, tenant.mngName )){
     
      props.swal("Tenant Required Fields are EMPTY!")
    }else{
    setShowProcessing(true)
    let formData = new FormData(); 
    formData.append("tenantLogo" , filenames)
    formData.append("tname", JSON.stringify(tname) );
    formData.append("tenant", JSON.stringify(tenant) );
    formData.append("bank", JSON.stringify(bank) );
    formData.append("allowed", JSON.stringify(allowed) );
    formData.append("allowedCategories" , JSON.stringify(allowedCategories))
    formData.append("city", JSON.stringify(city) );
    formData.append("area", JSON.stringify(area) );
    props.API({
      method: "post",
      url : `tenant/utenant`,
      data: formData,
      headers : {"arixauth" : localStorage.getItem("arixauth") }
      }).then((res) => {
       props.swal("Tenant Updated!")
        setShowProcessing(false)
     
      }).catch(function (error) {
        setShowProcessing(false)
        try{
          if(error.response.status === 401){
            props.swal("Unauthorized, please login again.").then(t => {
                props.history.push(`/auth/login`)
            })   
          }else{
            props.swal(error.response.data.message)
          }
        } catch(e){
          props.swal("error processing request at this time, please contact support.")
        } 
        
  }) 
}
    //props.props.swal(msg)
}
  

  const cinputConfirmAlert = (xcc) => {
    props.swal({
      title: "Are you sure?",
      text: `You are updating Tenant Profile: ${tname.en}`,
      icon: "warning",
      dangerMode: true,
    })
    .then(willDelete => {
      if (willDelete) {
        setShowlist(!showlist); xcc === "u" ? submitUpdate() : submitCreate()
      }
    });
  
  };

  

  const handleClick = event => {
    hiddenFileInput.current.click();
  };

  const handleImg = (e) => {
    
    if(e.target.files[0]) {
            
        if(filenamevalid(e.target.files[0])){
          setFilenames(e.target.files[0])
          setImg({
            src: URL.createObjectURL(e.target.files[0]),
            alt: e.target.files[0].name
        });
        }else{
          props.swal("Invalid Filename")
        }
        
    
    }   
}




// fetch tenant for update 
  const ftenant = () => {
   
    setShowProcessing(true)
    props.API.get(`ten/ftenant/${props.user.Email}`,{headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
      //  props.props.swal(res.data.message)
                          setShowProcessing(false)
                           setUpdateMode(true)
                          setShowlist(false)
                        
                          setTname(res.data.data.tname)
                          setAllowed(res.data.data.allowed)
                          setArea(res.data.data.areas)
                          setCity(res.data.data.city)
                          setBank(res.data.data.bank)
                          setAllowedCategories({cars : res.data.data.cat_car_allowed , yacht : res.data.data.cat_yacht_allowed , machines : res.data.data.cat_machines_allowed})
                          setTenant({...res.data.data})
                          flogo(res.data.data.tuid)
      }).catch(function (error) {
        setShowProcessing(false)
        try{
          if(error.response.status === 401){
            props.swal("Unauthorized, please login again.").then(t => {
                props.history.push(`/auth/login`)
            })   
          }else{
            props.swal(error.response.data.message)
          }
        } catch(e){
          props.swal("error processing request at this time, please contact support.")
        } 

       // console.log(error)
       // props.props.swal("Error fetching tenant by ID")
      }) 
  }

  const flogo = (tuid) => {
    setShowLogoProcessing(true)
    props.API.get(`tenant/tlogo/${tuid}`,{headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
      //  props.props.swal(res.data.message)
        setShowLogoProcessing(false)
        setImg({
          src:`data:image/${res.data.ftype};base64,${res.data.bdata}`
          ,alt : "file"})               
      }).catch(function (error) {
        setShowLogoProcessing(false)
        console.log(error)
       // props.props.swal("Error fetching tenant by ID")
       setImg({
        src : dp,
        alt : ""
      })
      try{
        if(error.response.status === 401){
          props.swal("Unauthorized, please login again.").then(t => {
              props.history.push(`/auth/login`)
          })   
        }else{
          props.swal(error.response.data.message)
        }
      } catch(e){
        props.swal("error processing request at this time, please contact support.")
      } 

      }) 
  }


  // Change Password
  const cangep = (f) => {
    f.preventDefault()
    setShowProcessing(true)
    props.API.post(`ten/rnmcp`, {guid : tenant.managerid, opass : opass, cpass : cpass},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
       props.swal(res.data.message)
        setShowProcessing(false)
        setShowpwc(false)
      }).catch(function (error) {
        setShowProcessing(false)
         console.log(error)
         if(error.response.status === 401){
          props.swal("Unauthorized, please login again.").then(t => {
              props.history.push(`/auth/login`)
          })   
        }else{
          props.swal("Error Resetting Password")
        }
        
      })      
  }

  const pwchange = () => {
    return (
      <Modal isOpen={showpwc}>
        <ModalHeader  toggle={p => setShowpwc(false)}></ModalHeader>
        <ModalBody>
          <Row>
            <Col></Col>
            <Col md="4">Old</Col>
            <Col md="6"><Input type="text" onChange={d => setOpass(d.target.value)} maxLength={24} /></Col>
            <Col></Col>
          </Row>
          <Row style={{marginTop : 10}}>
            <Col></Col>
            <Col md="4">New</Col>
            <Col md="6"><Input type="text" maxLength={24} onChange={d => setCpass(d.target.value)}/></Col>
            <Col></Col>
          </Row>
          <hr />
          <Row>
            <Col><center><Button size="sm" color={"warning"} onClick={f => cangep(f)}>Update</Button></center></Col>
          </Row>
        </ModalBody>
      </Modal>
    )
  }

  return (
    <>
    {pwchange()}
  {showProcessing && props.Spin } 
    <input
         ref={hiddenFileInput}
         type="file" 
         accept=".png, .jpg, .jpeg" 
         id="photo" 
         className="visually-hidden"
         onChange={e=> handleImg(e)}
         hidden/>

    {alert}
        
                <div className="content">
                <Row>
                  <Col md="4">
                    <Card className="card-user">
                    
                      <CardBody>
                       
                        <div >
                            <center>
                            
                            <img
                              alt="..."
                              width={"200px"}
                              src={src}
                              style={{ cursor : "pointer"}} 
                              onClick={e => {
                                handleClick(e)
                              }}
                         />
                          <h5 className="title">{tname.en} Tenant</h5>
                          <p className="description">xyz@tenant.com</p></center>
                        </div>
                            <center>
                                {tenant.addressIsVerified && tenant.cellIsVerified && 
                                <Badge className="shadow" style={{color :"black"}}>
                                &#9733; Verified
                                </Badge>
                                }
                              </center>
                        <p className="description text-center">
                                
                          If Phone, Landline, Address having <br />
                          checkboxes are checked <br />
                                "
                        </p>
                        <CardFooter>
                            <center>
                            <h6>Allowed Catagories</h6>
                            </center>
                              <Row style={{color : "gray"}}>
                                <Col>
                                <FormGroup>
                                <Input
                                                addon
                                                aria-label="Checkbox for following text input"
                                                type="checkbox"
                                                checked = {allowedCategories.cars}
                                                onChange={() => {}}
                                                readOnly
                                            />{' '}
                                  <i className="fa fa-car" aria-hidden="true">{' '}Car</i>
                                  </FormGroup>
                                </Col>
                                <Col>
                                <FormGroup>
                                    <Input
                                                addon
                                                aria-label="Checkbox for following text input"
                                                type="checkbox"
                                                checked = {allowedCategories.machines}
                                                onChange={() => {}}
                                                readOnly
                                            />{' '}
                                  <i className="fa fa-gears" aria-hidden="true">{' '}Machine</i>
                                  
                                  </FormGroup>
                                </Col>
                                <Col>
                                <FormGroup>
                                    
                                    <Input
                                                addon
                                                aria-label="Checkbox for following text input"
                                                type="checkbox"
                                                checked = {allowedCategories.yacht}
                                                onChange={() => {}}
                                                readOnly
                                            />
                                    <i className="fa fa-ship" aria-hidden="true">{' '}Yacht</i>                                
                                  </FormGroup>
                                </Col>
                              </Row>
                            <Row>
                                <Col>
                                <hr />
                                  <center>
                                  <FormGroup>
                                  <h6>Rating</h6>
                                <Rating
                                   readonly
                                initialValue={tenant.rating}
                                size = "20"
                                allowFraction	
                                 />
                                 <br />
                                {/** <p style={{marginTop : 15}}>.5 denomination</p> */}
                                    
                                    </FormGroup>
                                    </center>
                              </Col>
                            </Row>
                        </CardFooter>
                      </CardBody>
                    
                    </Card>


                    <Card>
                      <CardHeader>
                        <CardTitle tag="h4">Listing Permissions</CardTitle>
                      </CardHeader>
                      <CardBody>
                        <ul className="list-unstyled team-members">
                          <li>
                            <Row>
                              <Col md="2" xs="2">
                                      <i className="fa fa-list-alt" style={{fontSize : 30, marginTop : 5}} aria-hidden="true"></i>
                              </Col>
                              <Col md="7" xs="7">
                                Listings Allowed<br />
                                <span className="text-muted">
                                <small>
                                    {
                                      editP.listing &&  <Input
                                          type="text"
                                          value = {allowed.listing}
                                          readOnly
                                      />
                                    }
                                    {!editP.listing && allowed.listing}
                                  
                                  </small>
                                </span>
                              </Col>
                              <Col className="text-right" md="3" xs="3">
                                
                              </Col>
                            </Row>
                          </li>
                          <hr />
                          <li>
                            <Row>
                              <Col md="2" xs="2">
                                <i className="fa fa-th-list" style={{fontSize : 30, marginTop : 5}} aria-hidden="true"></i>
                              </Col>
                              <Col md="7" xs="7">
                                Allowed Premium <br />
                                <span className="text-success">
                                  <small>
                                    {
                                      editP.premium &&  <Input
                                          type="text"
                                          value = {allowed.premium}
                                          readOnly
                                      />
                                    }
                                    {!editP.premium && allowed.premium}
                                  
                                  </small>
                                </span>
                              </Col>
                              <Col className="text-right" md="3" xs="3">
                               
                              </Col>
                            </Row>
                          </li>
                          < hr />
                          <li>
                            <Row>
                              <Col md="2" xs="2">
                                    <i className="fa fa-list-ol" style={{fontSize : 30, marginTop : 5}} aria-hidden="true"></i>
                              </Col>
                              <Col className="col-ms-7" xs="7">
                                Allowed Featured <br />
                                <span className="text-danger">
                                <small>
                                    {
                                      editP.featured &&  <Input
                                          type="text"
                                          value = {allowed.featured}
                                          readOnly
                                      />
                                    }
                                    {!editP.featured && allowed.featured}
                                  
                                  </small>
                                </span>
                              </Col>
                              <Col className="text-right" md="3" xs="3">
                              
                              </Col>
                            </Row>
                          </li>
                        </ul>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="8">
                    <Card>
                      <CardHeader>
                        <h5 className="title">Tenant Profile  {tenant.tuid !== "" ? `TUID : ${tenant.tuid}` : ""} <i className="fa fa-floppy-o" onClick={x => { tenant.tuid !== "" ? cinputConfirmAlert("u") : cinputConfirmAlert("c") }} style={{float : "right", cursor : "pointer"}} aria-hidden="true"></i> </h5>
                        
                      </CardHeader>
                      <CardBody>
                        <Form > 
                          <Row>
                            <Col className="pr-1" md="6">
                              <FormGroup>
                                <label>Company (disabled)</label>
                                <InputGroup>
                                    
                                    <Input
                                        disabled = {updateMode}
                                        placeholder="Company"
                                        type="text"
                                        value = {tname.en}
                                        onChange={x => {
                                          setTname({en : x.target.value, fr : tname.fr, ar : tname.ar})
                                        }}
                                    />
                                    <InputGroupText>
                                    <i className="fa fa-globe" aria-hidden="true"></i>
                                    </InputGroupText>
                                </InputGroup>

                              
                              </FormGroup>
                            </Col>{/** 
                            <Col className="pr-1" md="4">
                              <FormGroup>
                                <label>..</label>
                                <InputGroup>
                                    
                                    <Input
                                        placeholder="Company"
                                        type="text"
                                        maxLength={25}
                                        value = {tname.fr}
                                        onChange={x => {
                                          setTname({en : tname.en, fr : alphaspace.test(x.target.value) ? x.target.value: "" , ar : tname.ar})
                                        }}
                                    />
                                    <InputGroupText>
                                    Fr
                                    </InputGroupText>
                                </InputGroup>

                              
                              </FormGroup>
                            </Col>*/}
                            <Col className="pr-1" md="6">
                              <FormGroup>
                                <label>..</label>
                                <InputGroup>
                                    
                                    <Input
                                    
                                        placeholder="Company"
                                        type="text"
                                        maxLength={25}
                                        value = {tname.ar}
                                        onChange={x => {
                                          setTname({en : tname.en, fr : tname.fr, ar : alphaspace.test(x.target.value) ? x.target.value: ""})
                                        }}
                                    />
                                    <InputGroupText>
                                    Ar
                                    </InputGroupText>
                                </InputGroup>

                              
                              </FormGroup>
                            </Col>
                            </Row>
                            <Row> 
                            <Col className="pr-1" md="6">
                              <FormGroup>
                              <label>Manager ID</label>
                                <InputGroup>
                                    <Input
                                       
                                        placeholder="Manager ID"
                                        type="text"
                                        value = {tenant.managerid}
                                        readOnly
                                        onChange={x => {
                                          setTenant({...tenant, managerid : x.target.value})
                                        }}
                                    />
                                    <InputGroupText>
                                    <i className="fa fa-key" aria-hidden="true" onClick={x => setShowpwc(true)}></i>
                                    </InputGroupText>
                                </InputGroup>
                              </FormGroup>
                            </Col>
                            <Col className="pl-1" md="6">
                              <FormGroup>
                                <label htmlFor="exampleInputEmail1">
                                  Enqury Email
                                </label>
                                <Input placeholder="Email" type="email" 
                                value={tenant.enqEmail}
                                maxLength={25}
                                onChange={x => {
                                  setTenant({...tenant, enqEmail : x.target.value ? x.target.value: ""})
                                }}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="pr-1" md="6">
                              <FormGroup>
                                <label>Manager Name</label>
                                <Input
                                  placeholder="Portal Manager (B.R)"
                                  type="text"
                                  maxLength={25}
                                  value = {tenant.mngName}
                                  onChange={x => {
                                    setTenant({...tenant, mngName : alphaspace.test(x.target.value) ? x.target.value: ""})
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col className="pl-1" md="6">
                              <FormGroup>
                                <label>Manager's Cell Number</label>
                                <Input
                                
                                  placeholder="Manager's Cell number"
                                  type="text"
                                  maxLength={13}
                                  value = {tenant.cellNumber}
                                  onChange={x => {
                                    setTenant({...tenant, cellNumber  : alphanum.test(x.target.value) ? x.target.value: ""})
                                  }}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="pr-1" md="4">
                              <FormGroup>
                                <label>Land Line</label>
                                <InputGroup>
                                    <InputGroupText>
                                    <Input
                                            addon
                                            aria-label="Checkbox for following text input"
                                            type="checkbox"
                                            checked = {tenant.cellIsVerified}
                                            readOnly
                                        />
                                    </InputGroupText>
                                    <Input
                               
                                  placeholder="Enquriy Number"
                                  type="text"
                                  value={tenant.landLine}
                                  onChange={x => {
                                    setTenant({...tenant, landLine : x.target.value})
                                  }}
                                />
                                </InputGroup>
                              
                              </FormGroup>
                            </Col>
                            <Col className="px-1" md="4">
                              <FormGroup>
                                <label>Whatsapp Number</label>
                                <Input
                                
                                  placeholder="Company Whatsapp Number"
                                  type="text"
                                  maxLength={13}
                                  value={tenant.waNumber}
                                  onChange={x => {
                                    setTenant({...tenant, waNumber : numdtest.test(x.target.value) ? x.target.value: ""})
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col className="pl-1" md="4">
                              <FormGroup>
                                <label>Cell Number</label>
                                <Input placeholder="Will be used by Admin to contact Tenant" type="text" 
                                   value = {tenant.cellNumberc}
                                   maxLength={13}
                                   onChange={x => {
                                    setTenant({...tenant, cellNumberc : numdtest.test(x.target.value) ? x.target.value: ""})
                                  }}
                                   />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="pr-1" md="4">
                              <FormGroup>
                                <label><i className="fa fa-youtube" aria-hidden="true"></i>{' '} Yourube </label>
                                <Input
                                
                                  placeholder="Youtube"
                                  type="text"
                                  maxLength={50}
                                  value={tenant.liProfile}
                                  onChange={x => {
                                    setTenant({...tenant, liProfile : x.target.value})
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col className="px-1" md="4">
                              <FormGroup>
                                <label><i className="fa fa-facebook" aria-hidden="true"></i> { ' '}Facebook </label>
                                <Input
                                 
                                  placeholder="Facebook Profile"
                                  type="text"
                                  maxLength={50}
                                  value={tenant.fbProfile}
                                  onChange={x => {
                                    setTenant({...tenant, fbProfile : x.target.value})
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col className="pl-1" md="4">
                              <FormGroup>
                                <label><i className="fa fa-instagram" aria-hidden="true"></i> {' '} Instagram</label>
                                <Input placeholder="Instagram" 
                                value = {tenant.insProfile}
                                maxLength={50}
                                onChange={x => {
                                  setTenant({...tenant, insProfile : x.target.value})
                                }}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                              <FormGroup>
                              <label>Street Address</label>
                                <InputGroup>
                                    <InputGroupText>
                                    <Input
                                            maxLength={50}
                                            addon
                                            aria-label="Checkbox for following text input"
                                            type="checkbox"
                                            checked = {tenant.addressIsVerified}
                                            readOnly
                                        />
                                    </InputGroupText>
                                    <Input
                                      placeholder="Street Address"
                                      type="text"
                                      value={tenant.stAddr}
                                      maxLength={25}
                                      onChange={x => {
                                        setTenant({...tenant, stAddr : x.target.value})
                                      }}
                                    />
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="pr-1" md="4">
                              <FormGroup>
                                <label>City</label>
                                <Select options={storarea} styles={customStyles} 
                                   value={{label : city.en + ' ' + city.ar, value : city.cityCode}} 
                                   onChange={e=> {setCity({cityCode: e.value, en: e.label, fr: e.labelfr, ar: e.labelar});
                                          setArealist(e.areas.map(t => {
                                            return {
                                              ...t, value : t.areaCode, label: t.en, labelfr: t.fr, labelar : t.ar
                                            }
                                          }));  
                                          setArea({areaCode : "", en : "", fr : "", ar : ""})      
                                        }}
                                   />
                              </FormGroup>
                            </Col>
                            <Col className="px-1" md="4">
                              <FormGroup>
                                <label>Area</label>
                                <Select options={arealist} styles={customStyles} 
                                   value={{label : area.en + ' '+  area.ar , value : area.cityCode}} 
                                   onChange={e=> {setArea({areaCode: e.value, en: e.label, fr: e.fr, ar: e.ar}) }}
                                   />
                              </FormGroup>
                            </Col>
                            <Col className="pl-1" md="4">
                              <FormGroup>
                                <label>Postal Code</label>
                                <Input placeholder="Postal Code" 
                                type="text"
                                maxLength={10}
                                value = {tenant.postal}
                                onChange={x => {
                                  setTenant({...tenant, postal : numdtest.test(x.target.value) ? x.target.value: ""})
                                }}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="6">
                              <FormGroup>
                                <label>About Tenant</label>
                                <Input
                                  className="textarea"
                                  type="textarea"
                                  cols="80"
                                  rows="4"
                                  readOnly
                                  value={tenant.aboutWords}
                                  onChange={x => {
                                    setTenant({...tenant, aboutWords : x.target.value})
                                  }}
                                 
                                />
                              </FormGroup>
                            </Col>
                            <Col md="6">
                              <FormGroup>
                                <label>حول المستأجر</label>
                                <Input
                                  className="textarea"
                                  type="textarea"
                                  cols="80"
                                  rows="4"
                                  readOnly
                                  value={tenant.aboutWordsar}
                                  onChange={x => {
                                    setTenant({...tenant, aboutWordsar : x.target.value})
                                  }}
                                 
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Form>
                      </CardBody>
                    </Card>

                  </Col>
                </Row>
              </div>
      
      
      
    </>
  );
}
export default connect(null, {profileFetch} )(Tenant);

